import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import makeRequest from "../../api";
import { ringService } from "../../api/services";
import { toast } from "react-toastify";

const useFetchUserDataToShowRingStats = () => {
  const params = useParams();
  const userId = params.userId;
  const [userDetails, setUserDetails] = useState<any>({});

  useEffect(() => {
    if (!userId) {
      return;
    }
    try {
      const getUserData = async () => {
        const res = await makeRequest(ringService.getRingUserData(userId));
        setUserDetails({ ...res?.data?.body });
      };

      getUserData();
    } catch (error) {
      toast.error("Error fetching ring user data!");
    }
  }, [userId]);

  return userDetails;
};

export default useFetchUserDataToShowRingStats;
